import SimpleMap from '../modules/simple-map';
import Carousel from '../modules/carousel';
import Calendar from '../modules/calendar';
import Checkout from '../modules/checkout';
import Config from '../modules/calendar/util/config';

document.addEventListener('DOMContentLoaded', () => {
    const isPropertyPage = !window.location.pathname.split('/').includes('experiences')
    if (isPropertyPage) {
        Carousel.setup('.splide', {});
    }
    Calendar.setup('calendar');
    Checkout.setup('checkout');
    SimpleMap.setup();
});
